import { setShowListPane, setShowReadingPane } from "owa-mail-layout";
import { mailSxSCleanupRouteHandler } from "./mailSxSRouteHandler";
import selectRow from "./selectRow";
import { isReadingPanePositionOff } from "owa-mail-layout/lib/selectors/readingPanePosition";
import { logUsage } from "owa-analytics";
import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";

export interface SearchRouteParameters {
    rowId?: string;
}

export default function searchRouteHandler(parameters: SearchRouteParameters): void {
    if (isReadingPanePositionOff()) {
        logUsage("Search_ReadingPaneClosed", getGlobalSettingsAccountMailboxInfo(), [
            "BrowserBackButton",
        ]);
        setShowReadingPane(false);
        setShowListPane(true);
    }
    
    if (parameters.rowId) {
        selectRow(parameters.rowId);
    }
}

export function searchCleanupRouteHandler(oldRoute?: string[], 
/* eslint-disable-next-line owa-custom-rules/no-optional-any-parameter -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE! This code should be fixed by any developer touching this code
 *	> Optional function parameters should not have type "any". This can hide undefined/null references otherwise detectable by the transpiler. */
oldParameters?: any, newRoute?: string[], 
/* eslint-disable-next-line owa-custom-rules/no-optional-any-parameter -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE! This code should be fixed by any developer touching this code
 *	> Optional function parameters should not have type "any". This can hide undefined/null references otherwise detectable by the transpiler. */
newParameters?: any): boolean {
    const wasInSxS = !!oldRoute && oldRoute.some(value => value == "sxs");
    
    if (wasInSxS) {
        mailSxSCleanupRouteHandler(oldRoute, oldParameters, newRoute, newParameters);
        setShowReadingPane(false);
    }
    
    return false;
}
